/* This file was generated automatically. Do not edit manually. */

import { createPosMicrosIntegrationMicrosRepository as posMicrosIntegrationMicros } from './posMicrosIntegrationMicros';
import { createPosMicrosIntegrationPointofsalesRepository as posMicrosIntegrationPointofsales } from './posMicrosIntegrationPointofsales';
import { createPosMicrosIntegrationPosRepository as posMicrosIntegrationPos } from './posMicrosIntegrationPos';
import { createPosMicrosIntegrationTestRepository as posMicrosIntegrationTest } from './posMicrosIntegrationTest';

export * from './types';

export const posMicrosIntegrationApiBasePath = '/api/configuration';

export const posMicrosIntegrationRestRepositoryFactories = {
    posMicrosIntegrationMicros,
    posMicrosIntegrationPointofsales,
    posMicrosIntegrationPos,
    posMicrosIntegrationTest,
};
